module.exports = __webpack_public_path__ + "img/rabi-shaul.27ed5adc.jpg";